import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { DerDashboardPage } from '@/features/dashboards/pages/DerDashboardPage';
import { derDashboardSearchSchema } from '@/features/dashboards/types/dashboard.types';

export const Route = createFileRoute('/_auth/dashboards/der')({
  validateSearch: derDashboardSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="DER Dashboard">
      <Suspense fallback={<PageLoader />}>
        <DerDashboardPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
